import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function CarServiceBlog() {

  const blogData = [
    {
      id: 1,
      image: '/blogimg/carstartnahihorahi.webp',
      admin: 'Admin',
      date: '10 Jan 2025',
      title: 'Car Start Nahi Ho Rahi? Common Reasons',
      description:
        'Agar aapki car start nahi ho rahi hai toh iska reason battery, starter motor ya fuel system ho sakta hai.',
      Link: '/blog/carstartnahihorahi'  
    },
    {
      id: 2,
      image: '/blogimg/CarACThandiHawaNahiDeRaha.webp',
      admin: 'Admin',
      date: '15 Jan 2025',
      title: 'Car AC Thandi Hawa Nahi De Raha',
      description:
        'Car AC cooling kam hone ke peeche gas leak, compressor issue ya clogged filter ho sakta hai.',
      Link: '/blog/CarACThandiHawaNahiDeRaha'
    }
    ,
    {
      id: 3,
      image: '/blogimg/CarMileageProblem.webp',
      admin: 'Admin',
      date: '20 Jan 2025',
      title: "Is your car mileage problem affecting your car's performance?",
      description:
        "Discover how car mileage problems can impact your vehicle's performance and learn effective solutions to address these issues.",
      Link: '/blog/car-mileage-problem'
    }
  ];

  return (
    <>
    <Helmet>
      <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "Blog",
  "name": "AutoCare Car Repair Blog",
  "description": "Expert tips, car maintenance guides, and auto repair insights from AutoCare Car Repair.",
  "publisher": {
    "@type": "Organization",
    "name": "AutoCare Car Repair"
  }
}
`}
</script>
      <title>AutoCare Blog | Car Maintenance Tips & Troubleshooting</title>

      <meta
        name="description"
        content="Explore AutoCare's blog for expert car maintenance tips, troubleshooting guides, and the latest in luxury car care."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/blog"
      />
    </Helmet>
    <div className="container px-4 d-flex flex-wrap gap-4 my-4">
      {blogData.map((blog) => (
        <div className="card" style={{ width: '18rem' }} key={blog.id}>

          <img
            src={blog.image}
            className="card-img-top"
            alt={blog.title}
          />

          <div className="card-body">

            {/* Optional: Admin + Date (Bootstrap classes hi use ho rahi hain) */}
            <div className="d-flex justify-content-between text-muted mb-2" style={{ fontSize: '13px' }}>
              <span>{blog.admin}</span>
              <span>{blog.date}</span>
            </div>

            <h5 className="card-title">{blog.title}</h5>

            <p className="card-text">{blog.description}</p>

            {/* Agar routing baad me lagani ho */}
            <Link to={blog.Link} className="btn btn-primary">
             Read More
            </Link>

          </div>
        </div>
      ))}
    </div>
    </>
  );
}
